import * as React from 'react';
import { MultiSelectModal } from './MultiSelectModal';
import { PLAN_TYPE_LABELS } from '../../../Language/en';

export interface PlanTypeSelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (planTypes: string[]) => void;

  value: string[];
}

export const PlanTypeSelect = (props: PlanTypeSelectProps): React.JSX.Element => {
  const [value, setValue] = React.useState<string[]>(props.value);

  return (
    <>
      <div>
        <MultiSelectModal
          disabled={props.disabled}
          value={value}
          options={PLAN_TYPE_LABELS}
          modalSaveButtonLabel="Save Changes"
          modalTitle="Select"
          buttonSelectLabel="Choose"
          buttonEditLabel="Edit"
          onChange={(newValue) => {
            setValue(newValue);

            if (props.onChange) {
              props.onChange(newValue);
            }
          }}
        />
      </div>
    </>
  );
};
